import { createApp, h, ref, Ref, toRef } from 'vue';
import App_client from './App_client.vue';
// import store, {key} from './store';
import './styles/tailwind_client.css';
//import './styles/SchemaEditorStyle.pcss';

import i18nInstance from '@/utils/i18n';

import { createPinia } from 'pinia';

import 'pinia';
import { IsAdmin } from './injectionKeys';

declare module 'pinia' {
  export interface PiniaCustomStateProperties<S> {
    /**
     * 커스터 마이징 플러그인
     */

    /*
    // by using a setter we can allow both strings and refs
    set hello(value: string | Ref<string>)
    get hello(): string

    // you can define simpler values too
    simpleNumber: number
    */
  }
}

//weblate연동 작업??
let app = createApp({
  render:()=>h(App_client)
});

app.provide(IsAdmin, false);

function SecretPiniaPlugin() {
  return { secret: 'the cake is a lie' };
}
const pinia = createPinia();

const init = () =>{
  app.use(i18nInstance)
    //.use(store, key)
    .use(pinia /* .use(({store}) => {})) */ )
    .mount('#app');
};

init();



